/*!
 * KoliBri - The accessible HTML-Standard
 */
function buildDefaultPropsFromConfig(config) {
    var _a, _b;
    const defaults = {};
    for (const def of [...((_a = config.required) !== null && _a !== void 0 ? _a : []), ...((_b = config.optional) !== null && _b !== void 0 ? _b : [])]) {
        defaults[def.propName] = def.getDefaultValue();
    }
    return defaults;
}

function throwNoStateAccess() {
    throw new Error('This behavior does not use component state.');
}
class BaseWebComponent {
    constructor() {
        this.rawProps = {};
        this.setState = (key, value) => {
            this[key] = value;
        };
        this.getState = (key) => {
            return this[key];
        };
        this.stateAccess = {
            setState: this.setState,
            getState: this.getState,
        };
    }
    initRenderProps(config) {
        this.renderProps = buildDefaultPropsFromConfig(config);
    }
    setRawProp(key, value) {
        this.rawProps[key] = value;
    }
    getRawProp(key) {
        return this.rawProps[key];
    }
    setRenderProp(key, value) {
        if (this.renderProps) {
            this.renderProps[key] = value;
        }
    }
    getRenderProp(key) {
        return this.renderProps[key];
    }
}
BaseWebComponent.stateLess = Object.freeze({
    setState: throwNoStateAccess,
    getState: throwNoStateAccess,
});

export { BaseWebComponent as B, buildDefaultPropsFromConfig as b };
//# sourceMappingURL=base-web-component-D909Fl-Y.js.map

//# sourceMappingURL=base-web-component-D909Fl-Y.js.map